module.exports = __webpack_public_path__ + "static/media/award_2.54cb3d4c.jpg";